// Aynı ürün+dönem'deki (istenirse +fiyat +açıklama) borç satırlarını
// (ör. aynı ayda birden fazla fiziksel ürün biriminin borcu) tek bir özet
// satıra indirger — üst üste tekrarlayan satırlar yerine "N adet" ile net
// bir görünüm sağlar. FirmaCariModal ve Tahsilat Takibi ekranı arasında
// paylaşılır ki ikisi de aynı mantıkla gruplasın.
export const groupBorcRows = (rows, { groupByPriceAndDesc = true } = {}) => {
  const map = new Map();
  rows.forEach((b) => {
    const donem = b.donem_baslangic || b.tarih;
    const key = groupByPriceAndDesc
      ? `${b.urun_adi || "-"}|${donem}|${b.urun_birim_fiyat ?? ""}|${b.urun_aciklama || b.aciklama || ""}`
      : `${b.urun_adi || "-"}|${donem}`;
    if (!map.has(key)) {
      map.set(key, {
        donem,
        urun_adi: b.urun_adi || "-",
        urun_birim_fiyat: b.urun_birim_fiyat,
        aciklama: b.urun_aciklama || b.aciklama || "-",
        adet: 0,
        toplamTutar: 0,
        toplamKalan: 0,
      });
    }
    const entry = map.get(key);
    entry.adet += 1;
    entry.toplamTutar += Number(b.tutar || 0);
    entry.toplamKalan += Number(b.kalan_tutar || 0);
  });
  return Array.from(map.values()).sort((a, b) => new Date(b.donem) - new Date(a.donem));
};
